import React, { useState } from 'react';
import { useSelector } from 'react-redux';

const PodTypeSelector = ({ selectedPodType, onSelect }) => {
  const { podTypes } = useSelector((state) => state.podType);
  const [showModal, setShowModal] = useState(false);
  const [search, setSearch] = useState('');

  const filtered = podTypes.filter((pt) =>
    pt.podtype.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-600">Pod Type</label>
      <input
        type="text"
        readOnly
        value={selectedPodType?.podtype || ''}
        onClick={() => setShowModal(true)}
        className="w-full px-4 py-2 border rounded cursor-pointer bg-gray-50"
        placeholder="Select Pod Type"
      />

      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded w-96 max-h-[80vh] overflow-y-auto">
            <h3 className="text-xl font-bold mb-2">Select Pod Type</h3>
            <input
              className="w-full mb-3 px-3 py-2 border rounded"
              placeholder="Search pod type..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <ul className="space-y-2">
              {filtered.map((pt) => (
                <li
                  key={pt.id}
                  onClick={() => {
                    onSelect(pt);
                    setShowModal(false);
                  }}
                  className="cursor-pointer hover:bg-gray-100 p-2 rounded"
                >
                  {pt.podtype}
                </li>
              ))}
            </ul>
            <button onClick={() => setShowModal(false)} className="mt-4 text-blue-500">Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PodTypeSelector;